module.exports = [
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Vanguard Target Retirement Series",
		"fund_legal_name": "Vanguard Target Retirement 2050 Fund",
		"ticker": "VFIFX",
		"fund_id": "FSUSA072BK",
		"investment_vehicle_id": "FOUSA05HZH",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "TSP Lifecycle Funds",
		"fund_legal_name": "L 2050",
		"ticker": "N",
		"fund_id": "FTSP0L2050",
		"investment_vehicle_id": "STSP0L2050",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Fidelity Freedom Index Series",
		"fund_legal_name": "Fidelity Freedom Index 2050 Fund",
		"ticker": "FFOPX",
		"fund_id": "FSUSA0A7L8",
		"investment_vehicle_id": "F00000VQAG",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 1,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Fidelity Freedom Series",
		"fund_legal_name": "Fidelity Freedom 2050 Fund",
		"ticker": "FZTKX",
		"fund_id": "FSUSA0720M",
		"investment_vehicle_id": "F00000YHGH",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 5,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 4,
		"grade_hrc": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 3,
		"grade_military": 5,
		"grade_tobacco": 3,
		"strategy_name": "T. Rowe Price Retirement Series",
		"fund_legal_name": "T. Rowe Price Retirement 2050 Fund",
		"ticker": "TRJLX",
		"fund_id": "FSUSA07VNR",
		"investment_vehicle_id": "F00001GGK0",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 3,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "BlackRock LifePath Index",
		"fund_legal_name": "BlackRock LifePath® Index 2050 Fund",
		"ticker": "LIPKX",
		"fund_id": "FSUSA0BDPU",
		"investment_vehicle_id": "F00000MAPG",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Nuveen Lifecycle Index Series",
		"fund_legal_name": "Nuveen Lifecycle Index 2050 Fund",
		"ticker": "TLLIX",
		"fund_id": "FSUSA0A1NN",
		"investment_vehicle_id": "F000003V0I",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 1,
		"grade_rji": 2,
		"grade_hrc": 4,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Nuveen Lifecycle Series",
		"fund_legal_name": "Nuveen Lifecycle 2050 Fund",
		"ticker": "TFTIX",
		"fund_id": "FSUSA08I1X",
		"investment_vehicle_id": "FOUSA06MDL",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 5,
		"grade_hrc": 5,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"strategy_name": "Principal LifeTime Series",
		"fund_legal_name": "Principal LifeTime 2050 Fund",
		"ticker": "PPLIX",
		"fund_id": "FSUSA008T8",
		"investment_vehicle_id": "FOUSA02STA",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 1,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "Fidelity Freedom Blend Series",
		"fund_legal_name": "Fidelity Freedom Blend 2050 Fund",
		"ticker": "FHEDX",
		"fund_id": "FS0000DV7F",
		"investment_vehicle_id": "F000010OFJ",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 2,
		"grade_guns": 5,
		"grade_prison_industrial_complex": 3,
		"grade_military": 4,
		"grade_tobacco": 3,
		"strategy_name": "JPM SmartRetirement Series",
		"fund_legal_name": "JPMorgan SmartRetirement® 2050 Fund",
		"ticker": "JTSYX",
		"fund_id": "FSUSA08DFY",
		"investment_vehicle_id": "F00000U8A3",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"strategy_name": "State Street Target Retirement Series",
		"fund_legal_name": "State Street Target Retirement 2050 Fund",
		"ticker": "SSDLX",
		"fund_id": "FS0000AREA",
		"investment_vehicle_id": "F00000T8XK",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 2,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 4,
		"strategy_name": "JPMorgan SmartRetirement Blend Series",
		"fund_legal_name": "JPMorgan SmartRetirement® Blend 2050 Fund",
		"ticker": "JNYAX",
		"fund_id": "FS00009GKH",
		"investment_vehicle_id": "F00000O314",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 4,
		"grade_deforestation": 3,
		"grade_gender_equality": 2,
		"grade_dei": 2,
		"grade_rji": 3,
		"grade_hrc": 1,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_tobacco": 3,
		"strategy_name": "Fidelity Advisor Freedom Series",
		"fund_legal_name": "Fidelity Advisor Freedom 2050 Fund",
		"ticker": "FFFLX",
		"fund_id": "FSUSA0720K",
		"investment_vehicle_id": "FOUSA05HWG",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 3,
		"grade_fossil_insure": 2,
		"grade_deforestation": 3,
		"grade_gender_equality": 4,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": 4,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"strategy_name": "American Century One Choice Series",
		"fund_legal_name": "American Century Investments One Choice 2050 Portfolio",
		"ticker": "ARFVX",
		"fund_id": "FSUSA08UTQ",
		"investment_vehicle_id": "FOUSA06UA6",
		"sustainable_investment": 0
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 2,
		"grade_deforestation": 4,
		"grade_gender_equality": 4,
		"grade_dei": 5,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_guns": 2,
		"grade_prison_industrial_complex": 2,
		"grade_military": 3,
		"grade_tobacco": 2,
		"strategy_name": "Putnam Sustainable Retirement Series",
		"fund_legal_name": "Putnam Sustainable Retirement 2050 Fund",
		"ticker": "PRRUX",
		"fund_id": "FSUSA06IQM",
		"investment_vehicle_id": "FOUSA05GFW",
		"sustainable_investment": 1
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 4,
		"grade_gender_equality": 2,
		"grade_dei": 3,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_guns": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_tobacco": 3,
		"strategy_name": "BlackRock LifePath ESG Index Series",
		"fund_legal_name": "BlackRock LifePath ESG Index 2050 Fund",
		"ticker": "LEPKX",
		"fund_id": "FS0000G106",
		"investment_vehicle_id": "F00001579S",
		"sustainable_investment": 1
	},
	{
		"grade_fossil": 4,
		"grade_fossil_bank": 4,
		"grade_fossil_insure": 3,
		"grade_deforestation": 3,
		"grade_gender_equality": 1,
		"grade_dei": 2,
		"grade_rji": 1,
		"grade_hrc": 1,
		"grade_guns": 4,
		"grade_prison_industrial_complex": 4,
		"grade_military": 5,
		"grade_tobacco": 2,
		"strategy_name": "Fidelity Sustainable Target Date Series",
		"fund_legal_name": "Fidelity Sustainable Target Date 2050 Fund",
		"ticker": "FSYWX",
		"fund_id": "FS0000I42F",
		"investment_vehicle_id": "F00001F475",
		"sustainable_investment": 1
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/TargetDateSeries.json
// module id = 967
// module chunks = 0